import _ from 'lodash';
import { getState } from 'src/store';
import { getRevyreState } from '../selectors';
import { setIsDialogOpen } from '../slice';
import {
  fetchEntityList,
  fetchModuleConfig,
  syncWorkflowConfigToSlice,
} from '../thunk';

const onUpdate = async ({ dispatch, props }) => {
  const { domainType, workflowType, activityType } = props;
  await dispatch(fetchModuleConfig({ domainType, workflowType }));

  if (activityType) {
    dispatch(fetchEntityList({ domainType, payload: {} }));
  }
  dispatch(setIsDialogOpen(true));
};

const onDeactivate = ({ dispatch }) => {
  dispatch(setIsDialogOpen(false));
};

const onActivate = ({ dispatch }) => {
  const modulesConfig = getRevyreState(getState()).modules;
  if (_.isEmpty(modulesConfig)) {
    syncWorkflowConfigToSlice(dispatch);
  }
};

export default { onUpdate, onDeactivate, onActivate };
